import React from 'react';
import './Spinner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function Spinner({ size }) {
  if (logComponent('Spinner')) { console.debug('Spinner rendered'); }

  return (
    <div className="Spinner" style={{ height: size || '2rem', width: size || '2rem '}}>
      <FontAwesomeIcon icon="spinner" className="Spinner__svg" />
    </div>
    
  )
}